export default __webpack_public_path__ + "static/milestone-basis-a92c44de659fd5cf79b3e7c8f9245104.png";